import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import useGetUser from '@/features/User/hooks/useGetUser';
import Navbar from '@/components/Navbar';

const PublicRoutes = [
	'/',
	'/register',
	'/validate',
	'/validated',
	'/reset-password',
	'/reset-password/confirm',
];

const Authguard = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { user } = useGetUser();

	useEffect(() => {
		// If user is undefined, we are still loading the user
		if (user === undefined) return;
		// If user is null, we are not logged in
		if (user === null && !PublicRoutes.includes(location.pathname)) {
			return navigate('/', { replace: true });
		}
		// If user is logged in and on the home page, redirect to /home
		if (location.pathname === '/' && !!user)
			return navigate('/home', { replace: true });
		// If user is logged in and doesn't have a birthday, redirect to /profile/form
		if (user && !user?.birthday)
			return navigate('/profile/form', { replace: true });
	}, [user, location.pathname, navigate]);

	// If user is still loading, render nothing
	if (user === undefined) {
		return null;
	}

	return (
		<Navbar>
			<Outlet />
		</Navbar>
	);
};

export default Authguard;
